/**
 * Strings for image uploads: optimizing, upload and processing progress, the
 * crop editor ("Edit image"), animations that become stills, and images that
 * cannot be used.
 */
import type { Dict } from './core';

export const imageEn: Dict = {
  'img.optimizing': 'Optimizing… {n}%',
  'img.uploading': 'Uploading… {n}%',
  'img.processing': 'Processing…',
  'img.cancelOptimize': 'Stop optimizing {name}',
  'img.optimizedTitle': 'Optimized from {from} to {to}',
  'img.drop': 'Drop images to add them',
  'img.tooMany': {
    one: 'A message can carry only {n} image.',
    other: 'A message can carry up to {n} images.',
  },
  'img.mb': '{n} MB',
  'img.kb': '{n} KB',
  'img.edit.title': 'Edit image',
  'img.edit.reset': 'Reset',
  'img.edit.apply': 'Apply',
  'img.edit.zoom': 'Zoom',
  'img.edit.stageRole': 'image position',
  'img.edit.stage':
    'Drag to move the image. Arrow keys move it, plus and minus zoom, 0 resets, Enter applies.',
  'img.edit.help': 'Drag to move. Scroll, pinch or use the slider to zoom.',
  'img.still.stillOnly': "Animated images aren't supported here yet, so the first frame is used.",
  'img.still.tooLarge':
    'This animation is too large to send animated, so it will be sent as a still image.',
  'img.still.apng': 'Animated PNGs are sent as a still image.',
  'img.err.heic':
    "This browser can't open HEIC photos. Save the photo as JPEG or PNG and try again. On an iPhone, Settings › Camera › Formats › Most Compatible takes JPEG photos from now on.",
  'img.err.unsupported': "This file can't be used as an image. Try a JPEG, PNG, WebP or GIF.",
  'img.err.decode': "This image couldn't be read. It may be damaged; try another file.",
  'img.err.tooLarge': "This image couldn't be made small enough. Try a different image.",
};
